import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import App from "./App.vue";
import Post from "@/components/Post";
import PostList from "@/components/PostList";
import PageNotFound from "@/components/PageNotFound";
import About from "@/components/About";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", alias: ["/blog/"], component: PostList, props: {} },
    {
      path: "/blog/:id",
      component: Post,
      props: { title: "Test Title", date: "12/12/12", body: "test" },
    },
    { path: "/about", component: About, props: {} },
    { path: "/:pathMatch(.*)*", component: PageNotFound },
  ],
});

const app = createApp(App);
app.use(router);
app.mount("#app");
